export default __webpack_public_path__ + "static/media/question.73eb5024.svg";